import { Component, inject, OnDestroy } from '@angular/core'
import { ModalHeaderComponent } from '../modal-header/modal-header.component'
import { ModalBodyComponent } from '../modal-body/modal-body.component'
import { ModalFooterComponent } from '../modal-footer/modal-footer.component'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Subscription } from 'rxjs'
import { Filter, FilterService } from 'src/app/shared/services/filter/filter.service'
import { ActiveFilterListComponent } from '../../table/filters/active-filter-list/active-filter-list.component'
import { SelectMenuSearchComponent } from '../../table/filters/select-menu-search/select-menu-search.component'
import { LabeledPropertyComponent } from '../../labeled-property/labeled-property.component'
import { StringFilter } from 'src/app/shared/services/filter/string-filter'
import { HeaderModal } from '../../table/headers/table-header.component'

@Component({
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    ActiveFilterListComponent,
    SelectMenuSearchComponent,
  ],
  selector: 'app-string-filter-modal',
  template: `
    @if(filter){
      <div app-modal-header>{{ filter.state.config.meta.fieldDisplay }}</div>
      <div app-modal-body>
        <p>Select a filter value for the column {{ filter.state.config.meta.fieldDisplay }} below</p>
        <div app-labeled-property [label]="filter.state.config.meta.fieldDisplay">
          <div
          app-select-menu-search
          [name]="filter.state.config.meta.fieldName"
          [label]="filter.state.config.meta.fieldDisplay"
          [value]="searchValue"
          [showAdd]="filter.state.config.allowMultiple"
          (search)="onSearch($event)"
          (add)="setValue($event)"
          ></div>
        </div>
        <app-active-filter-list
          [filterGroup]="filter.state.config.meta.fieldGroup"
          [filterName]="filter.state.config.meta.fieldName"
        ></app-active-filter-list>
      </div>
      <div app-modal-footer>
        <button class="action-btn" (click)="onClose()">Close</button>
      </div>
    }
  `,
})
export class StringFilterModalComponent implements HeaderModal, OnDestroy {
  private modal = inject(NgbActiveModal)
  private filterService = inject(FilterService)

  private subscription = new Subscription()
  public filter: StringFilter | undefined
  public searchValue = ''

  public init(
    fieldGroup: string,
    fieldName: string,
  ): void {
    this.subscription.add(
      this.filterService.state(fieldGroup).subscribe((group) => {
        const filter = group[fieldName] as Filter | undefined
        if (filter?.type === 'STRING') {
          this.filter = filter
        }
      }),
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  onSearch(event: string) {
    const terms = event
      .split(',')
      .map((sp) => sp.trim())
      .filter(Boolean)

    if (terms.length > 1) {
      this.setValue(terms)
    }

    this.searchValue = terms.slice(-1)[0] ?? ''
  }

  setValue(val: string | string[]) {
    if (this.filter) {
      this.filterService.dispatch(StringFilter.AddStringsAction(
        { values: [val].flat() }, 
        this.filter.state.config.meta,
      ))
    }
  }

  onClose() {
    this.modal.close()
  }
}
